import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative" data-id="element-182" data-mp="2sjucdkpk94zj">
      <div className="max-w-4xl mx-auto text-center" data-id="element-183" data-mp="36ah957brgksz">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-184" data-mp="36c28rbcxmtxp">
          <div className="inline-flex items-center justify-center mb-6" data-id="element-185" data-mp="3bbeqjhoy5atf">
            <Clock className="w-12 h-12 text-red-400/80" data-id="element-186" data-mp="3p80ostsq51od" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-8" data-id="element-187" data-mp="3l89r064s5lac">
            Actúa Ahora — Esto Es Lo Que Pierdes Cada Día
          </h2>

          <p className="text-xl text-slate-300 mb-10" data-id="element-188" data-mp="1uwlwc58bwo4x">
            Cada día que sigues sin un sistema de promoción claro es un día que:
          </p>

          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-8 mb-12" data-id="element-189" data-mp="2supkzz0z5rwp">
            <div className="bg-navy-950/50 px-6 py-4 rounded-lg border border-red-900/30 w-full sm:w-auto" data-id="element-190" data-mp="2xtiznurzzoyg">
              <p className="text-slate-300" data-id="element-191" data-mp="32q9g4j7psmke">Creas contenido que no convierte</p>
            </div>
            <div className="bg-navy-950/50 px-6 py-4 rounded-lg border border-red-900/30 w-full sm:w-auto" data-id="element-192" data-mp="37k59t9gy3n9r">
              <p className="text-slate-300" data-id="element-193" data-mp="3chdtxflnm1dn">Mandas tráfico que no compra</p>
            </div>
            <div className="bg-navy-950/50 px-6 py-4 rounded-lg border border-red-900/30 w-full sm:w-auto" data-id="element-194" data-mp="3gho0atdcytt1">
              <p className="text-slate-300" data-id="element-195" data-mp="3lj4wwcot7u3t">Pierdes comisiones que alguien más está ganando en tu lugar</p>
            </div>
          </div>

          <p className="text-2xl font-serif text-white" data-id="element-196" data-mp="1r4kiuiuzuwte">
            El mercado no espera. Los compradores no esperan.{' '}
            <span className="text-gold-400" data-id="element-197" data-mp="1w4gm2fvvak7w">
              Tu ventana de oportunidad tampoco.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}